import { VoteAIRecommendationRequest, VoteAIRecommendationResponse } from '../voteairecommendation';
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceUrl } from '../utils/api';

export async function voteAIRecommendation(
    caseId: string,
    aiRecommendationId: string,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<VoteAIRecommendationResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const request: VoteAIRecommendationRequest = {
            caseId: caseId,
            aiRecommendationId: aiRecommendationId
        };

        const encodedRequest = VoteAIRecommendationRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const url = getServiceUrl('intakeservice', 'voteairecommendation');

        const response = await fetch(
            url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: base64
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): VoteAIRecommendationResponse => {
        return VoteAIRecommendationResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
